import { ICON_TYPES } from '../constants';

export const ListViewIcon = (): JSX.Element => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1528_3224)">
        <path
          d="M12.0002 2.00012H3.50024V3.00012H12.0002V2.00012Z"
          fill="#141414"
        />
        <path
          d="M12.0002 5.49988H3.50024V6.49988H12.0002V5.49988Z"
          fill="#141414"
        />
        <path d="M12.0002 9H3.50024V10H12.0002V9Z" fill="#141414" />
        <path
          d="M1 3.5C1.55228 3.5 2 3.05228 2 2.5C2 1.94771 1.55228 1.5 1 1.5C0.447715 1.5 0 1.94771 0 2.5C0 3.05228 0.447715 3.5 1 3.5Z"
          fill="#141414"
        />
        <path
          d="M1 7.00012C1.55228 7.00012 2 6.5524 2 6.00012C2 5.44784 1.55228 5.00012 1 5.00012C0.447715 5.00012 0 5.44784 0 6.00012C0 6.5524 0.447715 7.00012 1 7.00012Z"
          fill="#141414"
        />
        <path
          d="M1 10.4999C1.55228 10.4999 2 10.0522 2 9.49988C2 8.94759 1.55228 8.49988 1 8.49988C0.447715 8.49988 0 8.94759 0 9.49988C0 10.0522 0.447715 10.4999 1 10.4999Z"
          fill="#141414"
        />
      </g>
      <defs>
        <clipPath id="clip0_1528_3224">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

ListViewIcon.iconType = ICON_TYPES.LIST_VIEW;
